import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import Button from "@shared/components/ui-kit/form/Button/Button.web";
import Track from "@shared/modules/analytics/components/Track/Track.web";
import { useTranslation } from "@shared/utils/internationalization";

/**
 * Intended for use only with the checkout step components in the CheckoutSummary
 */
export function PurchaseButton({
  paymentFailures,
  onPurchaseClick,
  canCheckout,
}: {
  paymentFailures: number;
  onPurchaseClick: () => void;
  canCheckout: boolean;
}) {
  const { t } = useTranslation("checkout");
  const { isBasketUpdating } = usePublicBasket();

  return (
    <Track.Click
      analytics={{
        label: "complete-transaction-button",
        custom_params: { payment_failures: paymentFailures },
      }}
      enabled={canCheckout}
    >
      <Button.Solid
        data-testid="checkout-summary-complete-transaction"
        mt="md"
        width="100%"
        onClick={onPurchaseClick}
        isLoading={isBasketUpdating}
        isDisabled={isBasketUpdating}
      >
        {t("Complete transaction")}
      </Button.Solid>
    </Track.Click>
  );
}
